import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { DivBackgroundOpacity } from "@utils/extra-style";

const Quantity = (props) => {
  const { t, data } = props;
  return (
    <>
      <DivBackgroundOpacity opacity={data.isActive ? 1 : "0.2"}>
        {data.quantity + " " + t(data.unit)}
      </DivBackgroundOpacity>
    </>
  );
};

Quantity.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Quantity);
